// @generated by packages/platform/shared-system/scripts/generate.ts.

export const NATS_PUBLIC_SUBJECT_TEMPLATES = {
  walletQuoteBalance: "morfi.wallet.{wallet}.quote_balance.v0",
  marketTrade: "morfi.market.{market}.user.{user}.trade.v0",
  marketBoost: "morfi.market.{market}.user.{user}.boost.v0",
  marketBacking: "morfi.market.{market}.user.{user}.backing.v0",
  marketThesisUser: "morfi.market.{market}.user.{user}.thesis.v0",
  marketClaim: "morfi.market.{market}.user.{user}.claim.v0",
  marketBackerFeeClaim: "morfi.market.{market}.backer_fee_claim.v0",
  marketLifecycle: "morfi.market.{market}.lifecycle.v0",
  marketResolution: "morfi.market.{market}.resolution.v0",
  marketOutcomeInitialized: "morfi.market.{market}.outcome.{outcome}.initialized.v0",
  marketCreated: "morfi.market.created.v0",
  marketGraduated: "morfi.market.graduated.v0",
  marketThesis: "morfi.market.{market}.thesis.v0",
  marketVotes: "morfi.market.{market}.votes.v0",
  marketOutcomeSuggestion: "morfi.market.{market}.outcome_suggestion.v0",
  marketOutcomeSuggestionVoted: "morfi.market.{market}.outcome_suggestion_voted.v0",
  marketOutcomeAdded: "morfi.market.{market}.outcome_added.v0",
  giftEvent: "morfi.gift.{gift}.event.v0",
  userNotifications: "morfi.user.{user}.notifications.v0",
  userGift: "morfi.user.{user}.gift.v0",
  userContentSafety: "morfi.user.{user}.content_safety.v0",
  ammActivity: "morfi.amm.{mint}.user.{user}.activity.v0",
  leaderboardRow: "morfi.leaderboard.{kind}.{window}.row.v1",
  confirmedBlockmeta: "morfi.chain.blockmeta.confirmed.latest.v0",
} as const;

export const SUBJECT_WALLET_QUOTE_BALANCE_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.walletQuoteBalance;
export const SUBJECT_MARKET_TRADE_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketTrade;
export const SUBJECT_MARKET_BOOST_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketBoost;
export const SUBJECT_MARKET_BACKING_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketBacking;
export const SUBJECT_MARKET_THESIS_USER_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketThesisUser;
export const SUBJECT_MARKET_CLAIM_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketClaim;
export const SUBJECT_MARKET_BACKER_FEE_CLAIM_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketBackerFeeClaim;
export const SUBJECT_MARKET_LIFECYCLE_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketLifecycle;
export const SUBJECT_MARKET_RESOLUTION_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketResolution;
export const SUBJECT_MARKET_OUTCOME_INITIALIZED_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketOutcomeInitialized;
export const SUBJECT_MARKET_CREATED = NATS_PUBLIC_SUBJECT_TEMPLATES.marketCreated;
export const SUBJECT_MARKET_GRADUATED = NATS_PUBLIC_SUBJECT_TEMPLATES.marketGraduated;
export const SUBJECT_MARKET_THESIS_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketThesis;
export const SUBJECT_MARKET_VOTES_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketVotes;
export const SUBJECT_MARKET_OUTCOME_SUGGESTION_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketOutcomeSuggestion;
export const SUBJECT_MARKET_OUTCOME_SUGGESTION_VOTED_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketOutcomeSuggestionVoted;
export const SUBJECT_MARKET_OUTCOME_ADDED_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.marketOutcomeAdded;
export const SUBJECT_GIFT_EVENT_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.giftEvent;
export const SUBJECT_USER_NOTIFICATIONS_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.userNotifications;
export const SUBJECT_USER_GIFT_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.userGift;
export const SUBJECT_USER_CONTENT_SAFETY_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.userContentSafety;
export const SUBJECT_AMM_ACTIVITY_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.ammActivity;
export const SUBJECT_LEADERBOARD_ROW_TEMPLATE = NATS_PUBLIC_SUBJECT_TEMPLATES.leaderboardRow;
export const BLOCKMETA_CONFIRMED_SUBJECT = NATS_PUBLIC_SUBJECT_TEMPLATES.confirmedBlockmeta;


export const SDK_ANON_ALLOW_SUBJECTS = ["morfi.wallet.*.quote_balance.v0", "morfi.market.*.>", "morfi.gift.*.>", "morfi.amm.*.>", "morfi.leaderboard.>", "morfi.chain.blockmeta.confirmed.latest.v0"] as const;
export const SDK_USER_ALLOW_SUBJECT_TEMPLATES = ["morfi.user.{user}.notifications.v0", "morfi.user.{user}.gift.v0", "morfi.user.{user}.content_safety.v0"] as const;

export function sdkUserAllowSubjects(user: string): string[] {
  return [
    ...SDK_ANON_ALLOW_SUBJECTS,
    formatSubject("morfi.user.{user}.notifications.v0", { user }),
    formatSubject("morfi.user.{user}.gift.v0", { user }),
    formatSubject("morfi.user.{user}.content_safety.v0", { user }),
  ];
}

export function walletQuoteBalanceSubject(wallet: string): string {
  return formatSubject(SUBJECT_WALLET_QUOTE_BALANCE_TEMPLATE, { wallet });
}

export function marketTradeSubject(market: string, user: string = "*"): string {
  return formatSubject(SUBJECT_MARKET_TRADE_TEMPLATE, { market, user });
}

export function marketBoostSubject(market: string, user: string = "*"): string {
  return formatSubject(SUBJECT_MARKET_BOOST_TEMPLATE, { market, user });
}

export function marketBackingSubject(market: string, user: string = "*"): string {
  return formatSubject(SUBJECT_MARKET_BACKING_TEMPLATE, { market, user });
}

export function marketThesisUserSubject(market: string, user: string = "*"): string {
  return formatSubject(SUBJECT_MARKET_THESIS_USER_TEMPLATE, { market, user });
}

export function marketClaimSubject(market: string, user: string = "*"): string {
  return formatSubject(SUBJECT_MARKET_CLAIM_TEMPLATE, { market, user });
}

export function marketBackerFeeClaimSubject(market: string): string {
  return formatSubject(SUBJECT_MARKET_BACKER_FEE_CLAIM_TEMPLATE, { market });
}

export function marketLifecycleSubject(market: string): string {
  return formatSubject(SUBJECT_MARKET_LIFECYCLE_TEMPLATE, { market });
}

export function marketResolutionSubject(market: string): string {
  return formatSubject(SUBJECT_MARKET_RESOLUTION_TEMPLATE, { market });
}

export function marketOutcomeInitializedSubject(market: string, outcome: string): string {
  return formatSubject(SUBJECT_MARKET_OUTCOME_INITIALIZED_TEMPLATE, { market, outcome });
}

export function marketThesisSubject(market: string): string {
  return formatSubject(SUBJECT_MARKET_THESIS_TEMPLATE, { market });
}

export function proposalVoteSubject(market: string): string {
  return formatSubject(SUBJECT_MARKET_VOTES_TEMPLATE, { market });
}

export function outcomeSuggestionSubject(market: string): string {
  return formatSubject(SUBJECT_MARKET_OUTCOME_SUGGESTION_TEMPLATE, { market });
}

export function outcomeSuggestionVoteSubject(market: string): string {
  return formatSubject(SUBJECT_MARKET_OUTCOME_SUGGESTION_VOTED_TEMPLATE, { market });
}

export function outcomeAddedSubject(market: string): string {
  return formatSubject(SUBJECT_MARKET_OUTCOME_ADDED_TEMPLATE, { market });
}

export function giftEventSubject(gift: string): string {
  return formatSubject(SUBJECT_GIFT_EVENT_TEMPLATE, { gift });
}

export function userNotificationsSubject(user: string): string {
  return formatSubject(SUBJECT_USER_NOTIFICATIONS_TEMPLATE, { user });
}

export function userGiftSubject(user: string): string {
  return formatSubject(SUBJECT_USER_GIFT_TEMPLATE, { user });
}

export function userContentSafetySubject(user: string): string {
  return formatSubject(SUBJECT_USER_CONTENT_SAFETY_TEMPLATE, { user });
}

export function ammActivitySubject(mint: string, user: string = "*"): string {
  return formatSubject(SUBJECT_AMM_ACTIVITY_TEMPLATE, { mint, user });
}

export function leaderboardRowSubject(kind: string, window: string): string {
  return formatSubject(SUBJECT_LEADERBOARD_ROW_TEMPLATE, { kind, window });
}

function formatSubject(template: string, values: Readonly<Record<string, string>>): string {
  return template.replace(/\{([a-z][a-zA-Z0-9]*)\}/gu, (_, rawName: string) => {
    const value = values[rawName];
    if (value === undefined) throw new Error("missing subject token " + rawName);
    return assertSubjectToken(rawName, value);
  });
}

function assertSubjectToken(name: string, value: string): string {
  if (value.trim() === "") throw new Error("subject token " + name + " must be non-empty");
  if (value.includes(".")) throw new Error("subject token " + name + " must not contain dots");
  return value;
}
